import {useEffect, useState} from 'react'
import { useAuth } from '../context/AuthContext'
import "./ReservationDashboard.css"
import { CiCalendar } from "react-icons/ci";
import { IoIosTrendingUp, IoIosTrendingDown } from "react-icons/io";
import { SlPeople } from "react-icons/sl";
import { PiWarningCircle } from "react-icons/pi";
import { FaUser } from "react-icons/fa6";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import { MdPeopleAlt, MdTableRestaurant } from "react-icons/md";
import { Link } from 'react-router-dom';
import { IoCalendarSharp } from "react-icons/io5";
import { FaMoneyCheckDollar } from "react-icons/fa6";


const ReservationDashboard = () => {
    const {
            upcomingHotelReservations,
            business, 
            businessToken, 
            historyHotelReservations, 
            historyBasicReservations,
            upcomingBasicReservations, 
            todayBasicReservations,
            todayReservation,
            futureReservation,
            historyReservation
        } = useAuth()
    const [todayReservations, setTodayReservations] = useState([])
    const [futureReservations, setFutureReservations] = useState([])
    const [historyReservations, setHistoryReservation] = useState([])
    

    //dnesni cisla a srovnani s minulym tydnem
    const [lastweekNumber, setLastweekNumber] = useState(0)
    const [todayReservationNumber, setTodayReservationNumber] = useState(0)
    const [lastMonth, setLastMonth] = useState(0)
    const [currentMonth, setCurrentMonth] = useState(0)
    const [waitingReservation, setWaitingReservation] = useState(0)
    
    useEffect(() => {
        const todayDate = new Date()
        todayDate.setHours(0,0,0,0)
        const currentMonth = todayDate.getMonth()
        const currentYear = todayDate.getFullYear()

        const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1
        const lastMonthYear = currentMonth === 0 ? currentYear - 1 : currentYear

        if (business) {
            setTodayReservationNumber(todayReservations.length)

        }
        const allReservation = [
            ...futureReservations,
            ...historyReservations
        ]


        const sevenDaysBack = new Date(todayDate);
        sevenDaysBack.setDate(sevenDaysBack.getDate() - 6); // aktuální týden = 7 dní včetně dneška

        const fourteenDaysBack = new Date(todayDate);
        fourteenDaysBack.setDate(fourteenDaysBack.getDate() - 13); // minulý týden = 8–14 dní zpět
    
    
        const filteredData = allReservation.filter((reservation) => {
            const resDate = new Date(reservation.date)
            resDate.setHours(0,0,0,0)
            const sevenDayBack = new Date(todayDate.getTime() - 7*24*60*60*1000)
            return resDate.getTime() === sevenDayBack.getTime()
        })
        setLastweekNumber(filteredData.length)


        const filteredWeekData = allReservation.filter((reservation) => {
            const resDate = new Date(reservation.date)
            resDate.setHours(0,0,0,0)
            return resDate >= sevenDaysBack && resDate <= todayDate
        })
        setAllCurrentWeek(filteredWeekData.length)


        const filteredLastWeek = allReservation.filter((reservation) => {
            const resDate = new Date(reservation.date);
            resDate.setHours(0, 0, 0, 0);
            return resDate >= fourteenDaysBack && resDate < sevenDaysBack;
        });
        setAllLastweek(filteredLastWeek.length)


        const filteredCurrentMonth = allReservation.filter((reservation) => {
            const resDate = new Date(reservation.date)
            resDate.setHours(0,0,0,0)
            return resDate.getMonth() === todayDate.getMonth()
        })
        setCurrentMonth(filteredCurrentMonth.length)


        const filteredLastMonth = allReservation.filter((reservation) => {
            const resDate = new Date(reservation.date)
            resDate.setHours(0,0,0,0)
            const resMonth = resDate.getMonth()
            const resYear = resDate.getFullYear()
            return resMonth === lastMonth && resYear === lastMonthYear
        })
        setLastMonth(filteredLastMonth.length)


        const filteredWaitingReservation = allReservation.filter((reservation) => {
            const resStatus = reservation.status
            const currentDate = new Date()
            currentDate.setHours(0,0,0,0)
            const resDate = new Date(reservation.date)
            resDate.setHours(0,0,0,0)         
            return resDate > currentDate && resStatus === "pending"
        })
        setWaitingReservation(filteredWaitingReservation.length)

        
    }, [historyReservations, todayReservations.length, business, futureReservations])

    const percentChange = (current, previous) => {
        if (previous === 0) {
          return current > 0 ? <span className='dashboard-small-icon icon-green'>
            <IoIosTrendingUp size={20} />+{current * 100}%
          </span> : '0'
        }
        const result = Math.round(((current - previous) / previous) * 100)
        if (result > 0) {
          return <span className='dashboard-small-icon icon-green'>
            <IoIosTrendingUp size={20} />+{Math.abs(result)}%
          </span>
        } else if (result < 0) {
          return <span className='dashboard-small-icon icon-red'>
          <IoIosTrendingDown size={20} />-{Math.abs(result)}%
        </span>
        } else {
          return <span className='dashboard-small-icon icon-yellow'>0%</span>
        }
      }

    //tento tyden a srovnani s minulym tydnem
    const [allLastweek, setAllLastweek] = useState(0)
    const [allCurrentWeek, setAllCurrentWeek] = useState(0)

 
    useEffect(() => {

        if (business && businessToken) {
            const getStartTime = (r) => {
                const timeStr = Array.isArray(r.timeSlots) && r.timeSlots.length > 0 
                ? r.timeSlots[0]?.startTime 
                : r?.time

                return new Date(`1970-01-01T${timeStr}:00`)
            }

            const mergedReservation = [
                ...todayBasicReservations,
                ...todayReservation
            ].sort((a, b) => {
                return getStartTime(a) - getStartTime(b);
            }).filter((reservation) => {
              const filterData = reservation.unavailable
              const noName = reservation.name || reservation.user?.name || reservation.quest?.name || false
              return filterData !== true && noName !== false
            })
            setTodayReservations(mergedReservation)

        }
    
        
    },[business, businessToken, todayBasicReservations, todayReservation])

    useEffect(() => {
        if (business && businessToken) {
            const mergedReservation = [
                ...futureReservation,
                ...upcomingBasicReservations,
                ...upcomingHotelReservations
            ].filter((reservation) => {
              const filterData = reservation.unavailable
              const noName = reservation.name || reservation.user?.name || reservation.quest?.name || false
 
              return filterData !== true && noName !== false
            })
            setFutureReservations(mergedReservation)

        }
    }, [business, businessToken, futureReservation, upcomingBasicReservations, upcomingHotelReservations])

    useEffect(() => {
        if (business && businessToken) {
            const mergedReservations = [
                ...historyReservation,
                ...historyBasicReservations,
                ...historyHotelReservations
            ].filter((reservation) => {
              const filterData = reservation.unavailable
              const noName = reservation.name || reservation.user?.name || reservation.quest?.name || false

              return filterData !== true && noName !== false
            })
            setHistoryReservation(mergedReservations)

        }
    }, [business, businessToken, historyBasicReservations, historyHotelReservations, historyReservation])
/*
    useEffect(() => {
        console.log(todayReservations)
        console.log(futureReservations)
        console.log(historyReservations)
    }, [todayReservations, futureReservations, historyReservations])

    */
    
  return (
<div className='dashboard-background'>
    <div>
 <div className="dashboard-percent-container">
  <div className="dashboard-card">
    <div className="dashboard-card-header">
      <h3>Dnešní rezervace</h3>
      <CiCalendar size={30}/>
    </div>
    <h2 className="dashboard-value">{todayReservationNumber}</h2>
    <div className="dashboard-card-footer">
      <p>aktivních rezervací</p>
      <p className="dashboard-change">{percentChange(todayReservationNumber, lastweekNumber)}</p>
    </div>
  </div>

  <div className="dashboard-card">
    <div className="dashboard-card-header">
      <h3>Týdenní trend</h3>
      <IoIosTrendingUp size={30}/>
    </div>
    <h2 className="dashboard-value">{allCurrentWeek}</h2>
    <div className="dashboard-card-footer">
      <p>vs. minulý týden</p>
      <p className="dashboard-change">{percentChange(allCurrentWeek, allLastweek)}</p>
    </div>
  </div>

  <div className="dashboard-card">
    <div className="dashboard-card-header">
      <h3>Tento měsíc</h3>
      <SlPeople size={27} />
    </div>
    <h2 className="dashboard-value">{currentMonth}</h2>
    <div className="dashboard-card-footer">
      <p>vs. minulý měsíc</p>
      <p className="dashboard-change">{percentChange(currentMonth, lastMonth)}</p>
    </div>
  </div>

  <div className="dashboard-card">
    <div className="dashboard-card-header">
      <h3>Čekající</h3>
      <PiWarningCircle size={30}/>
    </div>
    <h2 className="dashboard-value">{waitingReservation}</h2>
    {waitingReservation === 0 && <div className="dashboard-card-footer">
      <p></p>
      <p className="dashboard-small-icon icon-green"><strong>POTVRZENO</strong></p>
    </div>}
  </div>
</div>

<div className='dashboard-container-with-calendar'>
        <div className='dashboard-reservation-container'>
            <div className='dashboard-reservation-header'>
                <h3>Dnešní rezervace</h3>
                <Link className="dashboard-link" to={`/business/profile/reservations`}>Správa rezervací</Link>
            </div>
            <div className='dashboard-reservation-content'>
                {
                    todayReservations.length > 0 ? todayReservations.map((reservation) => {
                        
                        return <div key={reservation._id} className='dashboard-reservation-info'>
                            <div className='dashboard-reservation-info-header'>
                                <div className='dashboard-reservation-info-name-section'>
                                <div className='dashboard-reservation-icon'>
                                    <FaUser size={25}/>
                                </div>
                                <div className='dashboard-reservation-description'>
  <p className='dashboard-reservation-description-name'>
    {reservation?.quest?.name || reservation?.user?.name || reservation?.name}
  </p>

  {reservation.service && (
    <div>
        <p>{reservation?.service?.name}</p>
      <p>
        <span className='icon-text'>
          <MdOutlineAccessTimeFilled size={15} /> {reservation?.timeSlots[0]?.startTime} - {reservation?.timeSlots[reservation.timeSlots.length - 1]?.endTime}
        </span>
      </p>
      
    </div>
  )}

  {reservation.numberOfPeople && (
    <div className="icon-row">
    <span className="icon-text">
      <MdOutlineAccessTimeFilled size={15} /> {reservation?.time}
    </span>
    <span className="icon-text">
      <MdPeopleAlt size={15} /> {reservation?.numberOfPeople}
    </span>
    {reservation.table && (
      <span className="icon-text">
        <MdTableRestaurant size={15} /> {reservation.table}
      </span>
    )}
  </div>
  )}
</div>
</div>
                                <div className='dashboard-reservation-status'>{reservation.status === "pending"
                                            ? <p className='icon-yellow'>Čeká na potvrzení</p>
                                            : reservation.status === "confirmed"
                                            ? <p className='icon-green'>Potvrzeno</p>
                                            : reservation.status === "cancelled" 
                                            ? <p className='icon-red'>Zrušeno</p>
                                            : <p className='icon-yellow'>Nespecifikováno</p>
                                            }</div>
                            </div>
                        </div>
                    })
                : <p>Dnes nemáte žádnou rezervaci</p>}
                
            </div>
        </div>
        <div>
            
        </div>
        <div className='calendars-payments-container'>
                <Link className='calendar-container' to={`/business/public/${business._id}/reservation`}>
                <IoCalendarSharp size={100}/>
                <p>Kalendář</p>
                </Link>

               <Link className='calendar-container' to="/business/profile/paymentform">
               <FaMoneyCheckDollar size={100}/>
                <p>Správa předplatného</p>
                </Link>

        </div>

        
    </div>
    </div>
    <div className='margin-top-50px'/>
    </div>
  )
}

export default ReservationDashboard